import React, { Fragment } from "react";
import CustomTextbox from "../../components/Forms/CustomInputs/CustomTextbox";
import { useSelector } from "react-redux";
import CustomDropdown from "../../components/Forms/CustomInputs/CustomDropdown";

const AddUpdateUI = ({ selectedState, setSelectedState, formik }) => {
  const { data: states } = useSelector((state) => state.state);
  const { values, errors, handleChange, handleBlur, setFieldValue } = formik;

  // Custom handler for City Code to only allow numbers (max 6 digits)
  const handleCityCodeChange = (e) => {
    const value = e.target.value;
    // Only allow numbers and limit to 6 digits
    if (/^[0-9]*$/.test(value) && value.length <= 6) {
      handleChange(e);
    }
  };

  // Handle paste event to filter out non-numeric characters (max 6 digits)
  const handleCityCodePaste = (e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData('text');
    const numericOnly = paste.replace(/[^0-9]/g, '');
    // Limit to 6 digits
    const limitedValue = numericOnly.substring(0, 6);
    if (limitedValue) {
      setFieldValue('code', limitedValue);
    }
  };

  // Handle key down to prevent non-numeric keys
  const handleCityCodeKeyDown = (e) => {
    // Allow: backspace, delete, tab, escape, enter, home, end, left, right, up, down
    if ([8, 9, 27, 13, 46, 35, 36, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode === 67 && e.ctrlKey === true) ||
      (e.keyCode === 86 && e.ctrlKey === true) ||
      (e.keyCode === 88 && e.ctrlKey === true)) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  };
  return (
    <Fragment>
      <CustomDropdown
        fieldName="state"
        values={selectedState}
        error={errors.state}
        label={"Select State"}
        classes={"col-md-12"}
        setFieldValue={setFieldValue}
        handleChange={(value) => setSelectedState(value)}
        options={
          states
            ? states?.map((data) => {
              return { label: data.name, value: data._id };
            })
            : []
        }
      />

      <CustomTextbox
        fieldName="name"
        value={values.name}
        error={errors.name}
        label={"City Name"}
        classes={"col-md-12"}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleChange}
      />

      {/* <CustomTextbox
        fieldName="code"
        value={values.code}
        error={errors.code}
        label={"City Code"}
        classes={"col-md-12"}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleCityCodeChange}
        inputProps={{
          onPaste: handleCityCodePaste,
          onKeyDown: handleCityCodeKeyDown,
          maxLength: 6
        }}
      /> */}
    </Fragment>
  );
};

export default AddUpdateUI;
